/* Celebration choices use native line properties; extras are real Shopify variants. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-celebration-cake]').forEach(product => {
      if (product.dataset.cakeReady) return;
      product.dataset.cakeReady = 'true';
      const form = product.querySelector('form[action*="/cart/add"]');
      const flavour = form.querySelector('[name="properties[Flavour]"]');
      const variant = form.querySelector('[data-variant-select]');
      const quantity = form.querySelector('[name="quantity"]');
      const extras = [...form.querySelectorAll('[data-cake-extra]')];
      const error = form.querySelector('[data-cake-error]');
      const submit = form.querySelector('[name="add"]');
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: product.dataset.currency || 'AUD' });
      let busy = false;
      function update() {
        form.querySelector('[data-flavour-description]').textContent = flavour.selectedOptions[0]?.dataset.description || '';
        let extraPrice = 0;
        extras.forEach(extra => {
          const checkbox = extra.querySelector('[data-cake-extra-check]');
          const fields = extra.querySelector('[data-extra-fields]');
          fields.hidden = !checkbox.checked;
          fields.querySelectorAll('input,textarea').forEach(input => { input.disabled = !checkbox.checked; input.required = checkbox.checked; });
          const count = Number(extra.querySelector('[data-extra-quantity]')?.value || 1);
          if (checkbox.checked && Number.isSafeInteger(count) && count > 0) extraPrice += Number(checkbox.dataset.price) * count;
        });
        const count = Number(quantity.value);
        const valid = Number.isSafeInteger(count) && count > 0 && extras.every(extra => !extra.querySelector('[data-cake-extra-check]').checked || !extra.querySelector('[data-extra-quantity]') || extra.querySelector('[data-extra-quantity]').checkValidity());
        const total = (Number(variant.selectedOptions[0]?.dataset.priceCents || 0) + extraPrice) * count;
        form.querySelector('[data-cake-total]').textContent = valid ? `Your selection: ${money.format(total / 100)}${extraPrice ? ' including extras' : ''}` : 'Check your quantities to see the total.';
      }
      form.addEventListener('input', update);
      form.addEventListener('change', update);
      update();
      async function addCake(event) {
        event?.preventDefault();
        event?.stopImmediatePropagation();
        if (busy || !form.reportValidity()) return;
        if (!flavour.value || ![...flavour.options].some(option => option.value === flavour.value && !option.disabled)) return;
        const count = Number(quantity.value);
        if (!Number.isSafeInteger(count) || count < 1) return;
        const properties = {};
        for (const [key, value] of new FormData(form)) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string' && value.trim()) properties[match[1]] = value.trim();
        }
        const selected = extras.filter(extra => extra.querySelector('[data-cake-extra-check]').checked);
        const group = `hb-${crypto.randomUUID()}`;
        if (selected.length) properties._hb_cake_group = group;
        const items = [{ id: Number(variant.value), quantity: count, properties }];
        for (const extra of selected) {
          const checkbox = extra.querySelector('[data-cake-extra-check]');
          const multiplier = Number(extra.querySelector('[data-extra-quantity]')?.value || 1);
          if (!Number.isSafeInteger(multiplier) || multiplier < 1 || !Number.isSafeInteger(count * multiplier) || checkbox.disabled) return;
          const extraProperties = { _hb_cake_parent: group, _hb_cake_multiplier: String(multiplier), 'For cake': product.querySelector('h1').textContent.trim() };
          const message = extra.querySelector('[data-postcard-message]')?.value.trim();
          if (checkbox.hasAttribute('data-postcard') && !message) {
            const field = extra.querySelector('[data-postcard-message]');
            field.setCustomValidity('Please enter your postcard message.');
            field.reportValidity();
            field.addEventListener('input', () => field.setCustomValidity(''), { once: true });
            return;
          }
          if (message) extraProperties.Message = message;
          items.push({ id: Number(checkbox.value), quantity: count * multiplier, properties: extraProperties });
        }
        busy = true;
        submit.disabled = true;
        submit.querySelector('span').textContent = 'Adding your cake…';
        form.setAttribute('aria-busy', 'true');
        error.hidden = true;
        try {
          const add = async body => {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, typeof body === 'string' ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body } : { method: 'POST', headers: { Accept: 'application/json' }, body });
            const result = await response.json();
            if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : 'We couldn’t add that selection.');
          };
          // A logo file can only travel as multipart form data, so the cake goes first and its extras follow.
          const logo = form.querySelector('[data-cake-logo]')?.files?.[0];
          if (logo) {
            const body = new FormData();
            body.append('id', items[0].id);
            body.append('quantity', items[0].quantity);
            Object.entries(items[0].properties).forEach(([key, value]) => body.append(`properties[${key}]`, value));
            body.append('properties[Logo]', logo);
            await add(body);
            if (items.length > 1) await add(JSON.stringify({ items: items.slice(1) }));
          } else await add(JSON.stringify({ items }));
          if (window !== window.parent && typeof window.parent.hbDrawerCartAdded === 'function') window.parent.hbDrawerCartAdded(window);
          else location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
        } catch (failure) {
          error.textContent = `${failure.message || 'We couldn’t confirm that your cake was added.'} Check your cart before trying again; your choices are still here.`;
          error.hidden = false;
          error.focus();
        } finally {
          busy = false;
          form.removeAttribute('aria-busy');
          submit.disabled = Boolean(variant.selectedOptions[0]?.disabled);
          submit.querySelector('span').textContent = submit.disabled ? 'Sold out' : 'Add to cart';
        }
      }
      // Capture first so quick-shop's generic single-item submit cannot drop paid extras.
      form.addEventListener('submit', addCake, true);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
